const updateItems = [
  { date: '2026.07.28', title: '暑期漫画狂欢季正式开启', desc: '海量热门漫画限时免费阅读，每日签到领取阅读券，畅读不停歇。', tag: '活动' },
  { date: '2026.07.25', title: '《斗破苍穹》漫画版突破1000话', desc: '经典IP漫画连载突破千话大关，萧炎炎帝之路再启新征程。', tag: '里程碑' },
  { date: '2026.07.22', title: '下拉式阅读体验全面升级', desc: '优化滚动加载速度，新增夜间模式与字号调节，阅读更舒适。', tag: '更新' },
  { date: '2026.07.18', title: '国产原创漫画扶持计划上线', desc: '51漫画联合多家漫画工作室，推出原创作者激励计划。', tag: '公告' },
  { date: '2026.07.15', title: '《凡人修仙传》漫画新篇章', desc: '韩立飞升灵界后的全新冒险，画质全面升级，视觉盛宴。', tag: '上新' },
  { date: '2026.07.10', title: '手机端网页版适配优化完成', desc: '移动端阅读体验大幅提升，加载速度提升40%，流量消耗降低。', tag: '优化' },
  { date: '2026.07.05', title: '热门漫画排行榜功能上线', desc: '实时追踪全网漫画热度，多维榜单帮你发现优质作品。', tag: '新功能' },
  { date: '2026.07.01', title: '51漫画平台月活突破500万', desc: '感谢每一位读者的支持与陪伴，我们将持续提供优质服务。', tag: '里程碑' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">平台动态、漫画更新、活动通知一手掌握</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updateItems.map((item, i) => (
              <div key={i} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                      <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        item.tag === '活动' ? 'bg-primary-100 text-primary-700' :
                        item.tag === '上新' ? 'bg-accent-100 text-accent-700' :
                        item.tag === '公告' ? 'bg-secondary-100 text-secondary-700' :
                        'bg-background-200 text-foreground-600'
                      }`}>{item.tag}</span>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}